import { AgencyOfficerDetailsPermissions } from '../models/officer-details.models';

export function compareValuesSelectedOfficerUid(previous: AgencyOfficerDetailsPermissions, current: AgencyOfficerDetailsPermissions): boolean {
  return previous.agencyOfficerDetails.uid === current.agencyOfficerDetails.uid;
}
